import React, { CSSProperties, useCallback } from "react";
import styles from "./index.module.scss";

import iWechat from "@/modules/tm/assets/detail/wechat.png";
import iContact from "@/modules/tm/assets/detail/chat.png";
import iLogo from "@/public/logo512.png";
import { Popover } from "antd";
import { getOssAssetsGenerator } from "@/common/defines/ali-oss";
import { ContactQQLink } from "@/common/components/contact-qq";

const ossGen = getOssAssetsGenerator("kst/");

export interface ITMDetailPersonAreaProps {
  style?: CSSProperties;
  avatar?: string;
  name?: string;
  phone?: string;
  wechatQRCode?: string;
}

const TMDetailPersonArea: React.FC<ITMDetailPersonAreaProps> = (props) => {
  // ---------------- Events ----------------

  // 点击 - 在线咨询
  const onTapContact = useCallback(() => {
    window.open(ContactQQLink);
  }, []);

  // ---------------- UI ----------------
  let noAvatar = !props.avatar || props.avatar.length === 0;
  let wechatQRCode =
    props.wechatQRCode && props.wechatQRCode.length > 0
      ? props.wechatQRCode
      : ossGen("hy-qrcode.png");

  // 微信二维码
  const wechatPopover = (
    <div className={`${styles.popWechat} flex-row-center`}>
      <img style={{width: 200, height: 200}} src={wechatQRCode} alt="" />
    </div>
  );

  return (
    <div className={styles.container} style={props.style}>
      <div className="flex-row flex-cross-axis-center">
        <img
          style={{ borderRadius: noAvatar ? 0 : undefined }}
          className={styles.avatar}
          src={noAvatar ? iLogo : props.avatar}
          alt=""
        />
        <div className="flex-col">
          <div className={styles.name}>{props.name}</div>
          <div className={styles.phone}>联系电话：{props.phone}</div>
        </div>
      </div>
      <div style={{ marginTop: 32 }} className="flex-row">
        <Popover placement="top" content={wechatPopover}>
          <div
            style={{ marginRight: 8, border: "1px solid #FFC400" }}
            className={`${styles.button} flex-row-center`}
          >
            <img src={iWechat} alt="" />
            <span style={{ color: "#FFC400" }}>微信联系</span>
          </div>
        </Popover>
        <div
          style={{ border: "1px solid #00A7EB" }}
          className={`${styles.button} flex-row-center`}
          onClick={onTapContact}
        >
          <img src={iContact} alt="" />
          <span style={{ color: "#00A7EB" }}>在线咨询</span>
        </div>
      </div>
    </div>
  );
};

export default TMDetailPersonArea;
